<template>
    <div class="upload-container" v-loading="upLoading">
	<el-dialog
		:visible.sync="dialogVisible"
		width="50%"
	>
		<img
			:src="dialogImageUrl"
			alt="Preview Image"
			style="width: 100%;"
		>
	</el-dialog>
	<el-upload
		ref="upload"
		:class="['upload-demo', fileList.length ? 'disabled' : '']"
		action="https://trade.baidu.com/platform/interface/uploadimg"
		:on-success="handleUploadSuccess"
		list-type="picture-card"
		:multiple="false"
		:before-remove="beforeRemove"
		:before-upload="beforeUpload"
		:file-list="fileList"
      >
		<div v-show="!dialogImageUrl" class="upload-area">
			<i slot="default" class="el-icon-plus"></i>
			<span class="upload-tips">{{content}}</span>
		</div>
		<div slot="file" slot-scope="{file}">
			<img
				class="el-upload-list__item-thumbnail"
				:src="file.url" alt=""
			>
			<span class="el-upload-list__item-actions">
				<span
					class="el-upload-list__item-preview"
					@click="handlePictureCardPreview(file)"
				>
					<i class="el-icon-zoom-in"></i>
				</span>
				<!-- <span
					class="el-upload-list__item-delete"
					@click="handleDownload(file)"
				>
					<i class="el-icon-download"></i>
				</span> -->
				<span
					class="el-upload-list__item-delete"
					@click="handleRemove(file)"
				>
					<i class="el-icon-delete"></i>
				</span>
			</span>
          </div>
      </el-upload>
    </div>
</template>
<script>
export default {
    props: ['content'],
    data() {
        return {
			upLoading: false,
            dialogImageUrl: '',
            dialogVisible: false,
            disabled: false,
			fileList: []
        };
    },
    methods: {
		updateFileList(newFileList) {
            this.fileList = newFileList
        },
		beforeUpload() {
			this.upLoading = true;
		},
		handleRemove(file) {
			// this.$refs.upload.remove(file);
			this.fileList = []
		},
		beforeRemove() {
			// 这是一个可选的钩子函数，可以在删除文件之前执行一些操作
			// 如果返回 false 或者返回 Promise 且被 reject，则停止删除
			return true;
		},
		handlePictureCardPreview(file) {
			this.dialogImageUrl = file.url;
			this.dialogVisible = true;
		},
		handleDownload(file) {
			// 下载文件
			console.log(file);
		},
		handleUploadSuccess(response, file, fileList) {
			this.upLoading = false;
			this.fileList = fileList;
			console.log(fileList, file)
			if (response.errno === 1) {
				alert(response.errmsg)
			} else {
				// 处理文件上传成功的逻辑
				this.$emit('upload-success', response); // 触发自定义事件，并将响应数据传递给父组件
			}
		}
    }
};
</script>
<style lang="less" scope>
.upload-container{
	margin: 20px;
	.disabled{
		.el-upload--picture-card{
			display: none;
		}
	}
	
}
.upload-area{
	border: 1px solid #dcdfe6;
	position: relative;
	.upload-tips{
		font-size: 12px;
		line-height: 20px;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, 50%);
	}
}
</style>


